import React from 'react';
import { Skeleton } from 'antd-mobile';
import styles from './styles.module.pcss';

const FeatureLoader: React.FC = () => {
  return (
    <div className={styles.spinHolder}>
      <Skeleton animated />
    </div>
  );
};

export default FeatureLoader;
